import { __decorate } from "tslib";
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { clearMsg } from '@blade-sxp/monitor/api/msg/index';
import { AlarmWebsocket } from '@blade/common/utils/websocket';
import { EventBus, EventKeys } from '@blade/common';
import MsgBoard from '@blade-sxp/monitor-center/pages/components/msg-alarm/board.vue';
import taskType from '@blade-sxp/monitor/lang/task-type';
import { getAlertFont } from '@blade-sxp/monitor/utils/transforms';
import { getAlarmList } from '@blade/common/api/alarm-center';
import { getPermissionList } from '@blade-sxp/account/api/role';
import { isEmpty } from 'lodash';
import { ControlModule } from '@blade-sxp/monitor/store/control';
let default_1 = class extends Vue {
    unreadNum = 0;
    badge = true;
    MAX_UNREAD_NUMBER = 99;
    msgDraw = false;
    ws;
    wsUrl = '';
    msgList = [];
    viewMsgList = [];
    messageSwitch = true;
    jumpDialog = true;
    created() {
        this.wsUrl =
            process.env.NODE_ENV === 'development' ? process.env.VUE_APP_MSG_WS : `wss://${window.location.host}/${process.env.VUE_APP_MSG_WS}`;
        // console.log('ws:', this.wsUrl);
        // this.messageSwitch = localStorage.getItem('messageSwitch') === 'true';
        this.jumpDialog = localStorage.getItem('messageSwitch') === 'true';
    }
    mounted() {
        this.getPermissionList();
    }
    getTaskList() {
        this.$refs.msgBoard?.getTaskList();
    }
    getPermissionList() {
        getPermissionList().then((res) => {
            const permission = res.find((item) => {
                return item.code === '02';
            });
            if (!isEmpty(permission)) {
                if (permission.enable) {
                    this.initWebSocket();
                    this.getHistoryData();
                    EventBus.$on(EventKeys.Logout, () => this.ws?.close());
                }
            }
        });
    }
    getViewNow() {
        this.msgList.unshift(...this.viewMsgList);
        if (this.msgList.length > 500) {
            this.msgList = this.msgList.slice(0, 500);
        }
        this.viewMsgList = [];
    }
    getHistoryData() {
        // , 'INCIDENT_FACE_UNMATCHED'
        //   | 'FACE_MATCH' // 人脸比中
        // | 'INCIDENT_FACE_UNMATCHED' // 人脸未比中
        // | 'FACE_PEDESTRIAN' // 人脸&人体识别
        const reqParam = {
            alertLevel: '',
            deviceIds: [],
            incidentStatus: 'CONTINUE',
            incidentTypes: [],
            keyWord: '',
            page: 1,
            size: 500,
        };
        this.jumpDialog = false; // 修改msgList但不希望自动弹窗
        getAlarmList(reqParam).then((res) => {
            if (res.list) {
                this.msgList = res.list;
            }
        });
    }
    handleUpdate(updateTarget) {
        const { id, status } = updateTarget;
        this.jumpDialog = false; // 修改msgList但不希望自动弹窗
        const position = this.msgList.findIndex((el) => {
            return el.id === id;
        });
        if (status === 'DELETE') {
            this.msgList.splice(position, 1);
        }
        else {
            const reqParam = {
                page: 1,
                size: this.msgList.length + this.viewMsgList.length,
                deviceIds: [],
                incidentStatus: null,
                incidentTypes: null,
            };
            getAlarmList({ ...reqParam }).then((res) => {
                if (res.list) {
                    const target = res.list.find((el) => {
                        return el.id === id;
                    });
                    if (target) {
                        this.msgList[position].incidentStatus = target.incidentStatus;
                        this.msgList[position].remark = target.remark;
                        if (Array.isArray(target.remarks)) {
                            const remarkObj = {
                                remark: target.remarks[0]?.remark,
                            };
                            this.msgList[position].remarks = [];
                            this.msgList[position].remarks.push(remarkObj);
                        }
                    }
                }
            });
        }
    }
    changeBadgeShow(val) {
        // this.messageSwitch = val;
        // if (val) {
        //   if (this.unreadNum > 0) {
        //     this.msgList.unshift(...this.viewMsgList);
        //     if (this.msgList.length > 500) {
        //       this.msgList = this.msgList.slice(0, 500);
        //     }
        //   }
        //   this.viewMsgList = [];
        // }
    }
    websocketonmessage(e) {
        // 非数组或者对象则不进行匹配
        // console.log('数据', JSON.parse(e.data));
        if (!/({.*})|(\[.*\])/g.test(e.data))
            return;
        EventBus.$emit('alarm', JSON.stringify(JSON.parse(String.raw `${e.data}`)));
        let msgArr = JSON.parse(e.data);
        if (msgArr.incidentStatus === 'DELETE')
            return;
        let localArr = [];
        localArr.unshift(msgArr);
        this.unreadNum = this.unreadNum + 1;
        localArr = localArr.map((item) => {
            const { taskType, alertType } = item;
            const alertFont = this.$t(getAlertFont(taskType, alertType));
            return {
                ...item,
                alertFont,
            };
        });
        // this.msgList = this.msgList.filter((item: any) => {
        //   return item.incidentStatus === 'CONTINUE';
        // });
        if (msgArr.incidentType === 'FACE_MATCH') {
            const param = {
                trackId: String(msgArr.faceAnnotation.trackId),
                deviceId: String(msgArr.deviceId),
                taskId: String(msgArr.taskConsist.taskId),
                taskName: String(msgArr.taskConsist.taskName),
                level: String(msgArr.level),
            };
            ControlModule.addSelectMap(param);
            ControlModule.setAlarmDeviceId(String(msgArr.deviceId));
            ControlModule.setAlarmTaskId(String(msgArr.taskConsist.taskId));
        }
        localArr = localArr.filter((e) => !this.msgList || !this.msgList.some((item) => item.id === e.id));
        if (this.messageSwitch) {
            this.msgList.unshift(...localArr);
            if (this.msgList.length > 500) {
                this.msgList = this.msgList.slice(0, 500);
            }
            this.jumpDialog = true;
        }
        else {
            this.viewMsgList.unshift(...localArr);
        }
        if (this.unreadNum && this.unreadNum > 0 && this.messageSwitch) {
            this.badge = false;
        }
    }
    getDateDiff(val) {
        const dateDiff = Date.now() - val;
        let minutes = Math.floor(dateDiff / 1000);
        if (minutes < 1) {
            minutes = 1;
        }
        return minutes;
    }
    initWebSocket() {
        this.ws = new AlarmWebsocket(this.wsUrl);
        this.ws.setOnMessage(this.websocketonmessage);
    }
    darwClear() {
        this.unreadNum = 0;
        this.badge = true;
        this.msgDraw = false;
        this.msgList = [];
        this.viewMsgList = [];
    }
    clearMsgNum() {
        clearMsg().then((res) => {
            this.unreadNum = res.data.data.unreadNum;
            this.badge = true;
        });
    }
    drawShow() {
        this.msgDraw = true;
        this.clearMsgNum();
    }
};
default_1 = __decorate([
    Component({
        name: 'MsgAlarm',
        components: { MsgBoard },
        i18n: {
            sharedMessages: taskType,
        },
    })
], default_1);
export default default_1;
